import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, patchState, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { exhaustMap, pipe, tap } from 'rxjs';

import { UserService } from '@core/services/user.service';
import { User } from '@stores/models/user/user';

export interface UserState {
  data: User | null;
  loading: boolean;
  loaded: boolean;
  error: HttpErrorResponse | null;
}

export const INITIAL_STATE: UserState = {
  data: null,
  loading: false,
  loaded: false,
  error: null
};

export const USER_STORE = signalStore(
  withState<UserState>(INITIAL_STATE),
  withMethods((store, userService = inject(UserService)) => ({
    loadUser: rxMethod<void>(
      pipe(
        tap(() =>
          patchState(store, { loading: true, loaded: false, error: null })
        ),

        exhaustMap(() =>
          userService.loadUser().pipe(
            tapResponse({
              next: user => {
                patchState(store, {
                  data: user,
                  loading: false,
                  loaded: true,
                  error: null
                });
              },

              error: (err: unknown) => {
                const httpError = err instanceof HttpErrorResponse ? err : null;

                patchState(store, {
                  loading: false,
                  loaded: true,
                  error: httpError
                });
              }
            })
          )
        )
      )
    )
  }))
);
